var Playlist                 = require("./Playlist"),
    RepeaterArrayDataAdapter = require("enyo-ui/RepeaterArrayDataAdapter"),
    SimpleRepeater           = require("enyo-ui/SimpleRepeater"),
    frameThrottle            = require("enyo-perf/utils").frameThrottle,
    get                      = require("object-path").get,
    kind                     = require("enyo/kind");

require("./Playlists.less");

module.exports = kind(/** @lends  app.ArtistPage.Playlists.prototype */ {

    /**
     * @private
     */
    name: "app.ArtistPage.Playlists",

    /**
     * @private
     */
    classes: "app-artist-page-playlists",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * @private
     */
    components: [{
        name:            "playlists",
        kind:            SimpleRepeater,
        classes:         "app-artist-page-playlists__playlists",
        dataAdapterKind: RepeaterArrayDataAdapter,
        childKind:       Playlist
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        this.$.playlists.set("data", get(this.state, "data.playlists", []));
    }

});
